/**
 * True when the static custom cart drawer is visible on the storefront.
 * Drawer UI renders inside #popup-preview-shadow-root (open shadow), so
 * document.querySelector cannot see it without piercing the shadow root.
 */
export function isStaticCartDrawerOpen() {
  if (typeof window === "undefined") return false;
  if (window.__WEUPSELL_STATIC_CART_DRAWER_OPEN__) return true;
  try {
    const host = document.getElementById("popup-preview-shadow-root");
    if (host?.shadowRoot?.querySelector(".weu-custom-cart-drawer--live")) {
      return true;
    }
    return !!document.querySelector(".weu-custom-cart-drawer--live");
  } catch (_) {
    return false;
  }
}
